import type { EventId } from '@ps/isp-web-services-types';
import React from 'react';

import EventStatus from '@swf/sports/components/EventStatus/EventStatus';
import type { EventTypeId } from '@swf/sports/types/eventType';

import styles from './ScoreboardWrapper.scss';

interface Props {
  eventTypeId: EventTypeId;
  eventId?: EventId;
  eventTime: string;
}

const ScoreboardWrapper: React.FC<React.PropsWithChildren<Props>> = ({
  eventTypeId,
  eventId,
  eventTime,
  children
}) => (
  <div className={styles.wrapper} data-testid="scoreboard">
    <div className={styles.status}>
      <EventStatus
        eventId={eventId}
        isInPlay
        isTurnInPlay
        startTime={eventTime}
        size="XSmall"
        eventTypeId={eventTypeId}
      />
    </div>
    {children}
  </div>
);

export default ScoreboardWrapper;
